import { IInfo, IMerchant } from "@interfaces";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import styled from "styled-components";

interface CustomProfileCircleProps {
    merchant: IMerchant;
    userInfo: IInfo | null;
    pointValue: any;
}

export default function CustomProfileCircle({
    merchant,
    userInfo,
    pointValue,
}: CustomProfileCircleProps) {
    const themeColor = merchant.themes?.themeColor;

    // const rightCircle = merchant.customizeProfile.rightCircle;

    const rightCircle = merchant.themes?.customizeProfile.rightCircle;

    const setColor = userInfo?.memberTier?.color;

    const hexToRgb = (setColor: any) => {
        // Remove the '#' character if present
        setColor = setColor.replace("#", "");

        // Convert the hex code to RGB
        const r = parseInt(setColor.substring(0, 2), 16);
        const g = parseInt(setColor.substring(2, 4), 16);
        const b = parseInt(setColor.substring(4, 6), 16);

        return `linear-gradient(180deg,rgba(${r}, ${g}, ${b}, 0.2) 1%,rgba(${r}, ${g}, ${b}, 1) 70%)`;
    };

    const rgbColor = hexToRgb(setColor || "#FFFFFF");

    const MemberTeirProgress = () => {
        return (
            <div className="box-circular">
                <CircularProgressbar
                    value={
                        pointValue?.isBalance && userInfo?.BalancePointToNextTier !== 0
                            ? pointValue?.attentPercent
                            : pointValue?.nextTierPoint > 0
                            ? pointValue?.attentPercent
                            : 100
                    }
                    strokeWidth={10}
                    styles={buildStyles({
                        pathColor: `${userInfo?.memberTier?.color}`,
                        trailColor: `rgba(194, 198, 230, ${20 / 100})`,
                        backgroundColor: "#000",
                    })}
                />
                <StyledDotCircular
                    rotatevalue={pointValue?.attentPercent}
                    colortier={userInfo?.memberTier?.color}
                >
                    <div className="dot-circular"></div>
                </StyledDotCircular>
                <div className="text-circular">
                    <StyledColorTier color={userInfo?.memberTier?.color}>
                        {userInfo?.memberTier?.tierName}
                    </StyledColorTier>
                </div>
            </div>
        );
    };

    const MemberTierIcon = () => {
        return (
            <StyledMemberTier color={rgbColor}>
                <div className="box-tier-icon">
                    <img
                        src={
                            userInfo?.memberTier?.icon === "diamond"
                                ? "../../images/ic-diamond-tier.svg"
                                : userInfo?.memberTier?.icon === "star"
                                ? "../../images/ic-star-tier.svg"
                                : userInfo?.memberTier?.icon === "crown"
                                ? "../../images/ic-crown-tier.svg"
                                : "../../images/ic-membertype.png"
                        }
                        alt="Member Tier Icon"
                    />
                </div>
            </StyledMemberTier>
        );
    };

    const MemberType = () => {
        const selectedMemberType = merchant?.memberTypeConfig?.memberTypeGroupName
            .flatMap((group: { typeGroupNameList: any[] }) => group?.typeGroupNameList)
            .find((type: { _id: string }) => type._id === userInfo?.contact?.memberTypeNameId);

        return (
            <StlyedMemberType themeColor={themeColor!} color={setColor}>
                <img
                    src={
                        selectedMemberType
                            ? selectedMemberType.typeNameIcon
                            : "../../images/ic-membertype.png"
                    }
                    alt="Member Type Icon"
                />
            </StlyedMemberType>
        );
    };

    return (
        <>
            {rightCircle === "memberTeirProgress" && <MemberTeirProgress />}
            {rightCircle === "memberTeirIcon" && <MemberTierIcon />}
            {rightCircle === "memberType" && <MemberType />}
        </>
    );
}

//#region Styles

const StyledMemberTier = styled.div`
    .box-tier-icon {
        background: ${(props) => props.color};
        width: 90px;
        height: 90px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 100%;
        img {
            width: 35px;
        }
    }
`;

const StyledColorTier = styled.p`
    color: ${(props) => props.color || "#000"};
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 70px;
    font-weight: 600;
    text-align: center;
`;

const StlyedMemberType = styled.div<{ themeColor: string }>`
    display: flex;
    width: 90px;
    height: 90px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    border: 5px solid ${(p) => p.themeColor};
    img {
        width: 50px;
        height: auto;
    }
`;

const StyledDotCircular = styled.div<{ rotatevalue: string; colortier: string | undefined }>`
    transform: rotate(${(props) => (parseInt(props.rotatevalue) * 360) / 100 + "deg" || 0 + "deg"});
    position: absolute;
    .dot-circular {
        width: 6px;
        height: 6px;
        background-color: ${(props) => props.colortier};
        transform: translateY(-40px);
        border-radius: 100%;
    }
`;

//#endregion
